import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { View } from 'react-native';
import { createContainer } from '@dbk-legacy/muster/react';
import BlurModal from '../../../components/common/blur-modal';
import Text, { Large, H3, H4, H2 } from '@dbk/ui-text';
import BannerStyles from './awareness-banner.styles';
import Button from '@dbk/ui-buttons';
import { Contract } from '@dbk/ui-icons';
import DocsignBannerImage1 from '../../../assets/svgs/docsign-banner-image1';
import DocsignBannerImage2 from '../../../assets/svgs/docsign-banner-image2';

class BannerModal extends PureComponent {
    constructor() {
        super();
        this.state = { 
            esignBannerVisible: true
        };
        this.acceptClicked = this.acceptClicked.bind(this);
        this.notNowClicked = this.notNowClicked.bind(this);
    }

    acceptClicked() {
        this.props.docsign.setdocsignBannerSeen(true);
        this.props.setRsaPageName('/profile/docsign-subscription');
        this.props.rsa.onChangePage('/profile/docsign-subscription');
    }

    notNowClicked() {
        this.props.docsign.setdocsignBannerSeen(true);
    }

    componentDidMount() {
        this.props.saveUserSeenBanner(true);
    }

    render() {
        const {
      i18n: { messages }
    } = this.props;
        return (
            <BlurModal
                visible={this.state.esignBannerVisible}
                doneVisible={false}
                size={'large'}
                // headerChildren={'eSignature'}
                onDone={this.notNowClicked}
            >
                <div className="docsign esign-banner-root margin-left-35 margin-right-35">
                    <div className="esign-banner-welcome-message">
                        <H3 secondary>{messages['app.docsign.welcometext']}</H3>
                    </div>
                    <div className="esign-banner-title row large-12 margin-top-10 margin-bottom-60">
                        <span className="large-4 banner-title-text" secondary>{messages['app.docsign.eSignatureText']}</span>
                        <Contract className="banner-title-icon" width={50} height={50} />
                    </div>
                    <div className="center-content">
                        <Large className="docsign-instruction-text text-center instructions-block" secondary>{messages['app.docsign.instructionText1']}</Large>
                    </div>
                    <div className="center-content">
                        <Large className="docsign-instruction-text text-center instructions-block" secondary>{messages['app.docsign.instructionText2']}</Large>
                    </div>
                    <div className="row center-content margin-bottom-10">
                        <DocsignBannerImage1 width={200} height={140} color={'#ED6B0F'} />
                        <DocsignBannerImage2 width={120} height={140} color={'#ED6B0F'} />
                    </div>
                    <div className="center-content">
                        <Large className="docsign-instruction-text text-center instructions-block"  secondary>{messages['app.docsign.instructionText3']}</Large>
                    </div>
                    <div className="large-12 docsign-banner-buttons">
                            <Button className="docsign-notnow-button large-4" tertiary onPress={this.notNowClicked}>
                                {messages['app.docsign.notNowDocSign']}
                            </Button>
                            <Button className="docsign-accept-button large-4" onPress={this.acceptClicked}>
                                {messages['app.docsign.acceptDocSign']}
                            </Button>
                    </div>
                </div>
            </BlurModal>
        )
    }
}

BannerModal.propTypes = {

};



export default createContainer({
    $queries: {
        i18n: { messages: true },
        saveUserSeenBanner: {
            $call: 'docsign.saveUserSeenBanner',
        },
        showUserBanner: {
            $call: 'docsign.showUserBanner',
        },
        config: {
            docsign: true
        },
        auth: {
            vascoFlow: true,
        },
        rsa: {
            rsaAuthorised: true,
            onChangePage: {
                $call: 'changePage',
            },
        },
        setRsaPageName: { $set: 'ui.state.rsaPageName' },
        vascoauthentication: {
            vascoAuthorised: true
        },
        docsign: {
            docsignBannerSeen: true,
            setdocsignBannerSeen: { $set: 'docsignBannerSeen' },
        }
    },
})(BannerModal);
